"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.StyledDeptName=exports.ItemHeadingWrapper=void 0;const ItemHeadingWrapper=exports.ItemHeadingWrapper=_styledComponents.default.div`
    margin: 1rem 0rem;
    display: flex;
    column-gap: 8px;
    padding: 0.375rem 0;
    border-top: 1px solid #c8c7cc;
    border-bottom: 1px solid #c8c7cc;
   
    .itemName{
    width: 240px;
    }

    .qtyHeading {
    width: 58px;
    }

    .price {
    width: 58px;
    text-align: right;
  }
`,StyledDeptName=exports.StyledDeptName=_styledComponents.default.div`
  display: flex;
  justify-content: center;
  background-color: #eaeaea;
  text-align: center;
  padding: 4px 0px;

  .dept-heading {
    color: white;
    border: 0.5px solid;
    border-radius: 20px;
    background: #514f50;
    padding: 8px;
    font-weight: 600;
  }
`;